export default {
  results: {},
  allResults: {},
  userList: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/kodirectory/state.js